<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";
import moment from "moment";
export default {
  components: {
    PagenationContainer
  },
  props: {
    purchaseHistorList: Array,
    sourceData: Object
  },
  data() {
    // const pageCount = this.sourceData.totalPages;
    return {
      checkBoxSelect: true,
      closePayment: false,
      defaultValue: {},
      pageCount: undefined,
      activePage: 1,
      tableData: [],
      dateRange: undefined
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const params = {
        patientId: this.$route.params.patientId,
        stationUUID: this.$route.params.stationId,
        page: this.activePage - 1,
        size: 10,
        // sort: "createdAt,DESC"
      };

      if (params.stationUUID == "undefined") {
        // 集团视光师，参数中省略stationID
        delete params.stationUUID;
      }

      if (this.dateRange && this.dateRange.length > 0) {
        params.start = this.dateRange[0];
        params.end = this.dateRange[1];
      }
      const systemLog = await this.$http.getPatientSystemLog(params);
      if (systemLog) {
        this.tableData = systemLog.content;
        this.pageCount = systemLog.totalPages;
      }
    },
    createdAtFormtter(row) {
      if (row.createdAt) {
        return moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "--";
      }
    },
    eventTimeFormtter(row) {
      if (row.eventTime) {
        return moment(row.eventTime).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "--";
      }
    },
    pageClick(page) {
      this.encodeToUrl({
        page: page
      });
    },
    handleCurrentChange(val) {
      this.activePage = val;
      this.loadData();
    },
    onDateChange() {
      this.activePage = 1;
      this.loadData();
    }
  }
};
</script>

<template>
  <div class="patientSystemLog">
    <div class="TextGroup">
      <div class="dataSearch">
        <span>日志时间筛选：</span>
        <el-date-picker
          v-model="dateRange"
          size="mini"
          class="dateRange"
          type="daterange"
          range-separator="至"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="onDateChange"
        ></el-date-picker>
      </div>
    </div>
    <el-table
      :data="tableData"
      class="patientSystemLogTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="logLevel" align="left" label="类型" width="75">
        <template slot-scope="scope">
          <img v-if="scope.row.logLevel === 'ERROR'" class="logIcon" src="@/assets/logError.png" />
          <img
            v-else-if="scope.row.logLevel === 'WARNING'"
            class="logIcon"
            src="@/assets/logWarning.png"
          />
          <img v-else class="logIcon" src="@/assets/logInfo.png" />
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        align="left"
        :formatter="createdAtFormtter"
        label="服务端时间"
        width="160"
      ></el-table-column>
      <el-table-column
        prop="createdAt"
        align="left"
        :formatter="eventTimeFormtter"
        label="客户端时间"
        width="160"
      ></el-table-column>
      <el-table-column prop="content" align="left" label="日志内容"></el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.patientSystemLog {
  .patientSystemLogTable {
    margin: 20px 2%;
    border: 1px;
    width: 97%;
    .logIcon {
      width: 20px;
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
  .TextGroup {
    margin: 20px 2%;
    border: 1px;
    width: 97%;

    .dataSearch {
      float: right;
      margin-bottom: 10px;
      .dateRange {
        width: 250px;

        .el-range-editor--mini.el-input__inner {
          height: 32px;
        }

        .el-range-editor.is-active,
        .el-range-editor.is-active:hover {
          border-color: #00c1de;
        }

        .el-date-table td.today span {
          color: #00c1de;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/patientManagement/patientSystemLog.vue